// extracted by mini-css-extract-plugin
module.exports = {"form":"AssetInformation_form__naOz8","input":"AssetInformation_input__2a5DQ","tabs":"AssetInformation_tabs__3KS7K","container":"AssetInformation_container__20bzv"};